import { defineComponent as _defineComponent } from 'vue'
import useHttpRequest from "@/composables/use-http-request";
import { onMounted } from "vue";
import store from "@/store";
import { useRouter } from "vue-router/composables";
import {
  useShowSuccessMessage,
  useShowWarningMessage,
} from "@/composables/use-notifications";


export default /*#__PURE__*/_defineComponent({
  __name: 'authenticating.component',
  setup(__props) {

const router = useRouter();

const logoutUser = async () => {
  store.commit("LOGOUT_USER");

  //Redirect to Login Page
  await router.replace({ path: "/login" });
  store.commit("SET_IS_AUTHENTICATING", false);
};

const refreshAccessToken = async () => {
  let shouldRedirectToHome = false;

  //If the user is not the dashboard page, then let them see directly
  if (window.location.href.indexOf("/dashboard/") === -1) {
    //If it's the login page, then, check if we have a device token then allow them to get an access token
    if (
      window.location.href.indexOf("/login") !== -1 &&
      localStorage.getItem("a-dt")
    ) {
      shouldRedirectToHome = true;
    } else {
      return store.commit("SET_IS_AUTHENTICATING", false);
    }
  }

  //Check if we have a device token and if we do not, then auto log them out
  if (!localStorage.getItem("a-dt")) {
    return logoutUser();
  }

  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    accessToken: string;
  }>({
    method: "GET",
    url: `staff/access-token?timestamp=${new Date().getTime()}`,
    loadingProperty: null,
    showSuccessMessage: false,
    isSilent: true,
  });

  if (!request) {
    return useShowWarningMessage(
      "Connection failed",
      "Unable to connect, please check your internet connection and Refresh this page",
      true
    );
  }

  if (request.success && request.message == "Access Token Refreshed") {
    store.commit("REFRESH_ACCESS_TOKEN", {
      accessToken: request.accessToken,
    });
    store.commit("SET_IS_AUTHENTICATING", false);

    if (shouldRedirectToHome) {
      useShowSuccessMessage(
        "Success",
        "You're already logged in, redirecting you to the dashboard"
      );
      await router.replace({ path: "/dashboard/home" });
    }
  } else {
    return logoutUser();
  }
};

onMounted(() => {
  refreshAccessToken();
});

return { __sfc: true,router, logoutUser, refreshAccessToken }
}

})